import { useLocation } from "react-router-dom";

function NotFound() {
    const location = useLocation();

    console.log(`[NotFound] Current path is: ${location.pathname}`);

    return <h1>We cannot find the page!</h1>;
}

export default NotFound;